import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';
import { AuthService } from '../core/auth.service';
import { HttpService } from '../core/http.service';
import { environment } from './../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

const baseUrl: string = environment.baseURL;

@Injectable({
  providedIn: 'root'
})
export class ApiCallService {
  constructor(
    private readonly httpService: HttpService,
    private readonly http: HttpClient,
    private readonly authService: AuthService
  ) {}

  /**
   * @param endPt api end point
   * @param values request body
   * @param loader show loader
   * @returns api response
   */

  post(endPt: string, values, loader: boolean, options = {}) {
    return this.httpService.httpRequest(`POST`, endPt, loader, values, options);
  }

  /**
   * @param endPt api end point
   * @param loader show loader
   * @returns api response
   */
  get(endPt: string, loader: boolean, options = {}, responseType?: any) {
    return this.httpService.httpRequest(`GET`, endPt, loader, {}, options, responseType);
  }

  /**
   * @param endPt api end point
   * @param values request body
   * @param loader show loader
   * @returns api response
   */
  patch(endPt: string, values, loader: boolean) {
    return this.httpService.httpRequest(`PATCH`, endPt, loader, values);
  }

  /**
   * @param endPt api end point
   * @param values request body
   * @param loader show loader
   * @returns api response
   */
  put(endPt: string, values, loader: boolean) {
    return this.httpService.httpRequest(`PUT`, endPt, loader, values);
  }

  /**
   * @param endPt api end point
   * @param loader show loader
   * @returns api response
   */
  delete(endPt: string, loader: boolean, values?) {
    return this.httpService.httpRequest(`DELETE`, endPt, loader, values);
  }

  /**
   * @param reqUrl list of get type api end points
   * @returns api response
   */
  parallelCall(reqUrl) {
    if (this.authService.getUserIndexedDb()) {
      const detailObj = this.authService.getUserIndexedDb() || '';
      httpOptions.headers = httpOptions.headers.set(
        'Authorization',
        String(detailObj.fm_user)
      );
    }
    const tempUrls = [];
    reqUrl.forEach((element) => {
      tempUrls.push(this.http.get(`${baseUrl}${element}`, httpOptions));
    });
    return forkJoin(tempUrls);
  }

  /**
   * @param endPt api end point
   * @param values request body
   * @param loader show loader
   * @returns api response
   */
  formDataPostType(endPt: string, values, loader: boolean,showProgress = false) {
    return this.httpService.formRequest(`POST`, endPt, loader, values,showProgress);
  }

  /**
   * @param endPt api end point
   * @param values request body
   * @param loader show loader
   * @returns api response
   */
  formDataPutType(endPt: string, values, loader: boolean) {
    return this.httpService.formRequest(`PUT`, endPt, loader, values);
  }

  /**
   * @param endPt api end point
   * @param values request body
   * @param loader show loader
   * @returns api response
   */
}
